import { el } from 'redom';

import StreamingBackgroundImage from 'assets/images/event-background-image.png';

class ViewerMode {

  constructor() {

    this.backgroundImageEl = el('img.created-view-viewer-mode-background-image', { src: StreamingBackgroundImage, alt: 'streaming background image' });

    this.meetingNotStartedLabelEl = el('label.meeting-not-yet-started-label', 'Please wait. Live streaming has not started yet.');

    this.el = el('.created-view-viewer-mode', [this.backgroundImageEl, this.meetingNotStartedLabelEl]);

  }

}

export default ViewerMode;